import { Action, createReducer, on } from '@ngrx/store';
import { initialThemeState, ThemeState } from './common.state';
import * as ThemeActions from './common.actions';

const _themeReducer = createReducer(
  initialThemeState,
  on(ThemeActions.setActiveTheme, (state, { theme }) => ({ ...state, theme }))
);

export function themeReducer(state: ThemeState | undefined, action: Action) {
  return _themeReducer(state, action);
}